import { ShareLinkMessengerMessage } from '../message/type/ShareLinkMessengerMessage';
import fetchLink from '../http/fetch-share-link-by-id';
import storeLink from '../storage/set-link';
import urlOpenMessage from '../message/url-open';
import postMessage from '../message/post';

type T = (message: ShareLinkMessengerMessage) => void;

const f: T = async (message) => {
    const id = message.payload.id as string;

    const { url, systemId } = await fetchLink(id);

    if (!url) return;

    if (systemId) {
        storeLink({ id, url, fetchCounter: 0 });
    }

    postMessage(window.parent, urlOpenMessage(url));
};

export default f;
